// extracted by mini-css-extract-plugin
export var lg = "_2c-4";
export var md = "_2c-3";
export var sm = "_2c-2";
export var xs = "_2c-1";
export var xxs = "_2c-0";